<div class="component-container" #pdfContent>

    <div class="container">
        <div class="success-header">
            <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            </div>
            <h1 class="success-title">Order Confirmed!</h1>
            <p class="success-subtitle">Thank you for your purchase. Your order has been successfully placed.</p>
            
            <div class="order-info">
                <div class="info-item">
                    <div class="info-label">Ref Number</div>
                    <div class="info-value">#{{ receipt?.ref }}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">Order Date</div>
                    <div class="info-value">{{ receipt?.orderDate | date }}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">Total Amount</div>
                    <div class="info-value">{{ ( receipt?.total / 100) | currency }}</div>
                </div>
            </div>
        </div>
        
        <div class="order-details">
            <h2 class="section-title">Order Details</h2>
            
            <div class="ordered-item" *ngFor="let item of receipt?.orderItems">
            
                <img [src]="item?.images[0].imageUrl" alt="Wireless Headphones" class="item-image">
                
                <div class="item-details">
                    <div class="item-name">{{ item?.product?.name }}</div>
                    <div class="item-variant">{{ item?.product?.model }}</div>
                </div>
                <div class="item-quantity">Qty: {{ item?.quantity }}</div>
                <div class="item-price">{{ ( item?.price / 100 ) | currency }}</div>
            </div>
        
            
            
            <div class="order-summary">
                <div class="summary-row">
                    <span class="summary-label">Subtotal</span>
                    <span class="summary-value">{{ ( receipt?.subtotal / 100 ) | currency}}</span>
                </div>
               
                <div class="summary-row">
                    <span class="summary-label">Tax</span>
                    <span class="summary-value">{{ ( receipt?.tax / 100 ) | currency }}</span>
                </div>
                <div class="summary-row">
                    <span class="summary-label">Discount</span>
                    <span class="summary-value">-{{ ( receipt?.discount / 100 ) | currency }}</span>
                </div>
                <div class="summary-row summary-total">
                    <span class="summary-label">Total Paid</span>
                    <span class="summary-value">{{ ( receipt?.subtotal / 100 ) | currency }}</span>
                </div>
            </div>
        </div>
        
        <div class="action-buttons">
            <!--
            <a href="#" class="btn btn-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 11l3 3L22 4"></path>
                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
                </svg>
                Track Your Order
            </a>
            -->
            <a class="btn btn-secondary" (click)="downloadReceipt()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                Download Receipt
            </a>
            
            <a [routerLink]="['/']" class="btn btn-outline">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.293 2.293c-.63.63-.184 1.707.707 1.707H19M7 13v6a2 2 0 002 2h2a2 2 0 002-2v-6"></path>
                </svg>
                Continue
            </a>
        </div>
        
        <div class="support-info">
            <h3>Need Help?</h3>
            <p>If you have any questions about your order, our customer support team is here to help.</p>
            
            <a [routerLink]="['/contact']" class="support-contact">Contact Support</a>
        </div>
    </div>
</div>